<template>

    <div class="container">

        <div class="handle-box-search">

            <el-row class="head-search">
                <el-col :span="8">
                    <span class="title">商家名称:</span>
                    <!-- 搜索司机名称-->
                    <el-input v-model="search_data.inspection_line_name" placeholder="请输入商家名称" style="width: 200px;"
                              @keyup.enter.native="searchinspectionLineLists">
                    </el-input>
                </el-col>


            </el-row>



            <el-button type="primary" icon="el-icon-search" @click="searchinspectionLineLists">搜索</el-button>
            <el-button @click="add_show = !add_show">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">


            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <!-- 表格下拉 -->

                        <el-form-item label="备注:">
                            <span>{{ props.row.remarks }}</span>
                        </el-form-item>



                    </el-form>
                </template>
            </el-table-column>







            <el-table-column prop="inspection_line_name" label="商家名称">
            </el-table-column>

            <el-table-column prop="inspection_line_phone" label="商家电话">
            </el-table-column>


            <el-table-column prop="time.YmdHis" label="创建时间">
            </el-table-column>


            <el-table-column label="操作">
                <template slot-scope="scope">

                    <el-dropdown split-button type="primary"
                                 @click="edit_show = !edit_show; edit_data = scope.row.inspection_line_code; "
                                 trigger="click">

                        编辑

                        <el-dropdown-menu slot="dropdown">

                            <el-dropdown-item @click.native="del(scope.row.inspection_line_code)">删除</el-dropdown-item>

                        </el-dropdown-menu>

                    </el-dropdown>

                </template>
            </el-table-column>

        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>


        <!-- 添加组件 -->
        <addInspectionLine :isShow="add_show" @onSubmit="inspectionLineLists"></addInspectionLine>



        <!-- 编辑组件 -->
        <editInspectionLine :isShow="edit_show" :data="edit_data" @onSubmit="inspectionLineLists">
        </editInspectionLine>

    </div>

</template>

<script>
    import addInspectionLine from './addInspectionLine.vue';
    import editInspectionLine from './editInspectionLine.vue';
    var _this;
    export default {
        components: {
            addInspectionLine,
            editInspectionLine
        },


        data() {
            return {


                add_show: false,
                edit_show: false,
                edit_data: '',

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    inspection_line_name: '',
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },
            };
        },
        created() {
            _this = this;
            _this.inspectionLineLists();
        },

        methods: {
            del(code) {

                _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning',

                }).then(() => {


                    _this.$post(
                        "/Inspectionline/deleteInspectionLineSubmit", {
                            inspection_line_code: code
                        }
                    ).then(res => {

                        _this.$message.success(res.msg);
                        _this.inspectionLineLists();

                    }).catch((err) => {

                    })





                }).catch(() => {

                    _this.$message({
                        message: '已取消删除',
                        duration: 1500
                    });

                });

            },



            searchinspectionLineLists() {

                _this.search_data.page = 1;
                _this.inspectionLineLists();

            },
            // 搜索司机日志列表
            inspectionLineLists() {
                _this.$post(
                    "/Inspectionline/inspectionLineLists",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                    }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.inspectionLineLists();

            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>